import { ApiCall } from "components/common/services/ApiServices";
import {
  BILLING_DETAILS,
  GET_PROFILE_DETAILS,
  REMENUARATION_DETAILS,
  SET_DROPDOWN_DATA,
  UPDATE_FIELDS,
  UPDATE_TAB_DATA,
} from "../../annotation/PlanningConstants";
import { COMPANY_MICROSERVICE } from "Constants";
import CustomNotify from "components/common/atoms/CustomNotify";
import { t } from "components/CentralDataMangement/translation/Translation";

export const fetchProfileDetails = async (
  type: "planningProfile" | "payProfile", // Dynamic type handling
  id: number | null | undefined,
  state: any,
  dispatch: React.Dispatch<any>
) => {
  if (type === "planningProfile") {
    //selected profile option
    const profileOption = state.dropDowndata.commercialProfileOptions.find(
      (option: any) => option.value === id
    );
    const data = {
      type: type,
      agreementId: profileOption.agreementId,
      functionId: profileOption.functionId,
    };
    if (id) {
      const response = await ApiCall.service(
        `${GET_PROFILE_DETAILS}`,
        "POST",
        data,
        false,
        COMPANY_MICROSERVICE
      );

      if (response?.status === 200) {
        const responseData = response?.data;
        if (Object.keys(responseData).length > 0) {
          dispatch({
            type: UPDATE_TAB_DATA,
            tab: BILLING_DETAILS,
            data: responseData,
          });
          let coef = state.billingDetails.coeffType === 0
            ? responseData?.payrollCoefficient
            : state.billingDetails.coeffType === 1
              ? responseData?.reduceCoefficient
              : state.billingDetails.coeffType === 2
                ? responseData?.selectionCoefficient
                : responseData?.coefficient

          dispatch({
            type: UPDATE_FIELDS,
            tab: BILLING_DETAILS,
            field: 'holidayCoeff',
            value: coef,
          });

          dispatch({
            type: UPDATE_FIELDS,
            tab: BILLING_DETAILS,
            field: 'coefficient',
            value: coef,
          });

          const pcEmpTypes = state.basicDetails.partiarCommittee && responseData?.dropdownData?.coopPcEmpTypeLinking
            ?.filter(
              (option: any) => state.basicDetails.partiarCommittee?.value == option.pcId)
            .map((option: any) => (option.empTypeId));

          const employeeTypeOptions = state.dropDowndata.empTypes.filter((option: any) => pcEmpTypes.includes(option?.value));

          dispatch({ type: SET_DROPDOWN_DATA, payload: { ...responseData?.dropdownData, employeeTypeOptions }});
        }
      }else {
      CustomNotify({
        type: "error",
        message: t("Some error occured")
      })
    }
    }
  } else if (type === "payProfile") {

    const payProfileOption = state.dropDowndata.payProfileOptions.find(
      (option: any) => option.value === id
    );
    const adminFicheId = payProfileOption.adminFicheId;
    if (adminFicheId) {
      const data = {
        type: type,
        adminFicheId: adminFicheId,
        empTypeId: id,
      };
      const response = await ApiCall.service(
        `${GET_PROFILE_DETAILS}`,
        "POST",
        data,
        false,
        COMPANY_MICROSERVICE
      );
      if (response?.status === 200) {
        const responseData = response?.data;
        if (Object.keys(responseData)?.length > 0) {
          dispatch({
            type: UPDATE_TAB_DATA,
            tab: REMENUARATION_DETAILS,
            data: responseData,
          });
        }
      }else {
      CustomNotify({
        type: "error",
        message: t("Some error occured")
      })
    }
    }
  }
};
